import { render } from "./RobotContent.vue?vue&type=template&id=1f57be2c"
import script from "./RobotContent.vue?vue&type=script&lang=js"
export * from "./RobotContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__